import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * A proposal opens in its drawer over the screen (spec 030): an old link to its own page lands on
 * the deals with the drawer open.
 */
export const Route = createFileRoute('/_app/proposals/$proposalId')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/deals',
      search: { proposal: params.proposalId } as never,
      replace: true,
    });
  },
});
